import React, { useState } from 'react';
import { ChevronDown, ChevronRight, FileSignature, ListChecks } from 'lucide-react';
import { Card } from '@/components/ui/card';
import VencimientosPlazoFijoTab from './VencimientosPlazoFijoTab';
import MatrizMaestraRRHH from './MatrizMaestraRRHH';

/**
 * "Controles" — Centro de Control de Personal (RRHH).
 *   Bloque 1: Alertas de Vencimiento de Contratos a Plazo Fijo (colapsable).
 *   Bloque 2: Matriz Maestra de Funcionarios y Novedades del Mes.
 */
export default function ControlesRRHHTab() {
  const [openVenc, setOpenVenc] = useState(true);
  const [openMatriz, setOpenMatriz] = useState(true);

  return (
    <div className="space-y-4">
      {/* Bloque superior — Vencimientos */}
      <Card className="overflow-hidden border-slate-200" data-testid="controles-bloque-vencimientos">
        <button
          onClick={() => setOpenVenc(v => !v)}
          className="w-full px-4 py-3 flex items-center justify-between bg-slate-50 hover:bg-slate-100 border-b border-slate-200"
          data-testid="controles-toggle-vencimientos"
        >
          <div className="flex items-center gap-2">
            <FileSignature className="w-4 h-4 text-rose-600" />
            <h3 className="text-sm font-bold text-slate-800">Alertas de Vencimiento de Contratos a Plazo Fijo</h3>
          </div>
          {openVenc ? <ChevronDown className="w-4 h-4 text-slate-500" /> : <ChevronRight className="w-4 h-4 text-slate-500" />}
        </button>
        {openVenc && (
          <div className="p-4">
            <VencimientosPlazoFijoTab />
          </div>
        )}
      </Card>

      {/* Bloque inferior — Matriz Maestra */}
      <Card className="overflow-hidden border-slate-200" data-testid="controles-bloque-matriz">
        <button
          onClick={() => setOpenMatriz(v => !v)}
          className="w-full px-4 py-3 flex items-center justify-between bg-slate-50 hover:bg-slate-100 border-b border-slate-200"
          data-testid="controles-toggle-matriz"
        >
          <div className="flex items-center gap-2">
            <ListChecks className="w-4 h-4 text-indigo-600" />
            <h3 className="text-sm font-bold text-slate-800">Matriz Maestra de Funcionarios y Novedades del Mes</h3>
          </div>
          {openMatriz ? <ChevronDown className="w-4 h-4 text-slate-500" /> : <ChevronRight className="w-4 h-4 text-slate-500" />}
        </button>
        {openMatriz && (
          <div className="p-4">
            <MatrizMaestraRRHH />
          </div>
        )}
      </Card>
    </div>
  );
}
